/* eslint-disable prettier/prettier */

import api from 'clients/api/Api';

import { IAuthResponse, IUserInfoResponse } from 'domains/auth/AuthDomain';

interface IParams {
  username: string;
  password: string;
}

const config = {
  headers: {
    'Content-Type': 'application/json',
  },
};

const generateAccessToken = async (params: IParams) => {
  const { data } = await api.post<IAuthResponse>(
    'cardio/User/GenerateAccessToken',
    params,
    config,
  );
  return data;
};

const getUserInfo = async token => {
  const { data } = await api.get<IUserInfoResponse>('cardio/User/Info', {
    headers: {
      ...config.headers,
      Authorization: `Bearer ${token}`,
    },
  });
  return data;
};

const searchUserBySector = async ({ UserRole, UserSector, Search }) => {
  const { data } = await api.get('cardio/User/UsersByHierarchy', {
    params: {
      Role: UserRole,
      Sector: UserSector,
      Search,
    },
    headers: {
      ...config.headers,
    },
  });
  return data;
};

const getUserAccess = async (params, token?: string) => {
  const { data } = await api.post(
    'cardio/User',
    params,
    token ? { headers: { Authorization: `Bearer ${token}` } } : undefined,
  );
  return data;
};

export const AuthService = {
  getUserAccess,
  searchUserBySector,
  generateAccessToken,
  getUserInfo,
};
